/**
 * Reemplazo de window.confirm para mantener UI consistente.
 * Uso:
 *   const [confirm, ConfirmUI] = useConfirm();
 *   if (await confirm('¿Eliminar?')) { ... }
 */

import { useState, useCallback } from 'react';
import { BRAND } from '@/constants/brand';

export function useConfirm() {
  const [state, setState] = useState({ open: false, message: '', resolve: null });

  const confirm = useCallback((message) => {
    return new Promise((resolve) => {
      setState({ open: true, message, resolve });
    });
  }, []);

  const handle = (value) => {
    state.resolve?.(value);
    setState({ open: false, message: '', resolve: null });
  };

  const ui = state.open ? (
    <div className="fixed inset-0 bg-black/80 backdrop-blur flex items-center justify-center z-50 p-4">
      <div className="bg-neutral-900 border border-neutral-800 rounded-2xl p-6 max-w-sm w-full">
        <p className="text-white text-sm mb-6">{state.message}</p>
        <div className="flex justify-end gap-2">
          <button
            onClick={() => handle(false)}
            className="px-4 py-2 text-sm text-neutral-400 hover:text-white"
          >
            Cancelar
          </button>
          <button
            onClick={() => handle(true)}
            className="px-5 py-2.5 rounded-lg font-medium"
            style={{ background: BRAND.gold, color: BRAND.black }}
          >
            Confirmar
          </button>
        </div>
      </div>
    </div>
  ) : null;

  return [confirm, ui];
}
